import React from 'react';
import { Box, Image, keyframes } from '@chakra-ui/react';

// Keyframes for the orbiting animation
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0% { transform: scale(1); opacity: 0.8; }
  50% { transform: scale(1.1); opacity: 1; }
  100% { transform: scale(1); opacity: 0.8; }
`;

export default function CobraSpinner({ size = "md", ...props }) {
  // Map standard Chakra Spinner sizes to pixel dimensions
  const sizeMap = {
    xs: "20px",
    sm: "28px",
    md: "40px",
    lg: "56px",
    xl: "80px",
  };

  // If size is a standard string, map it; otherwise use it as-is (e.g., "100px")
  const pixelSize = sizeMap[size] || size;
  
  // Calculate inner sizes based on the container size
  // Logo takes up 50% of the container
  // Dots take up 15% of the container

  return (
    <Box 
      position="relative" 
      width={pixelSize} 
      height={pixelSize} 
      display="inline-block"
      {...props}
    >
      {/* Central Pulsing Logo */}
      <Image 
        src="/assets/cobra.png" 
        alt="Loading..." 
        position="absolute"
        top="25%"
        left="25%"
        width="50%"
        height="50%"
        objectFit="contain"
        animation={`${pulse} 1.5s ease-in-out infinite`}
      />

      {/* Orbiting Dots Container */}
      <Box 
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        animation={`${spin} 1.5s linear infinite`}
      >
        {/* Top Dot - Blue */}
        <Box 
          position="absolute"
          top="0"
          left="50%"
          transform="translateX(-50%)"
          width="15%"
          height="15%"
          bg="#0b5cff" /* Modern blue */
          borderRadius="full"
          boxShadow="0 0 5px rgba(11,92,255,0.6)"
        />
        {/* Right Dot - Orange/Yellow */}
        <Box 
          position="absolute"
          top="50%"
          right="0"
          transform="translateY(-50%)"
          width="15%"
          height="15%"
          bg="#FFB800" /* Brand yellow/orange */
          borderRadius="full"
          boxShadow="0 0 5px rgba(255,184,0,0.6)"
        />
        {/* Bottom Dot - Teal/Green */}
        <Box 
          position="absolute"
          bottom="0"
          left="50%"
          transform="translateX(-50%)"
          width="15%"
          height="15%"
          bg="#38B2AC" /* Teal */
          borderRadius="full"
          boxShadow="0 0 5px rgba(56,178,172,0.6)"
        />
        {/* Left Dot - Red */}
        <Box 
          position="absolute"
          top="50%"
          left="0"
          transform="translateY(-50%)"
          width="15%"
          height="15%"
          bg="#ff2a2a" /* Red */
          borderRadius="full"
          boxShadow="0 0 5px rgba(255,42,42,0.6)"
        />
      </Box>
    </Box>
  );
}
